import styled from 'styled-components'

export interface CardPropsStyles {
  color: string
  backgroundColor: string
}

const labelHeight = 67

export const Wrapper = styled.a<CardPropsStyles>`
  cursor: pointer;
  display: flex;
  flex-wrap: wrap;
  transition: transform 0.3s ease 0.1s, height 0.3s ease 0.1s;
  transform-origin: center center;
  position: relative;
  overflow: hidden;
  background: ${p => p.backgroundColor};

  h3 {
    color: ${p => p.color};
  }

  &:hover,
  &:focus {
    transition: all 0.3s ease-in-out 0s;
  }

  img {
    width: 100%;
    max-width: 100%;
    height: auto;

    &.icon {
      width: 50px;
    }
  }
`

export const ImageContainer = styled.div`
  height: 150px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #0089ba;
  width: 100%;
`

export const TitleContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin: ${p => p.theme.spacing.small};
`

export const ItemTitle = styled.h3`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${labelHeight}px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;

  @media (max-width: 480px) {
    ${p => ({ ...p.theme.size.xs })};
  }

  @media (max-width: 768px) {
    ${p => ({ ...p.theme.size.sm })};
  }
`
